import React from 'react';
import PropTypes from 'prop-types';

import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()({
  wrapper: {
    width: '24px',
    height: '36px',
    padding: 0,
    border: 0,
    background: 'transparent',
    position: 'absolute',
    transition: 'transform 0.2s cubic-bezier(0.4, 0, 0.2, 1)',
    '&:hover > span': { transform: 'scale(1.5)' },
    '&:active > span': { transform: 'scale(0.95)' },
    top: 'calc(50% - 18px)',
    '&:focus-visible': { outline: '2px solid #477b39', outlineOffset: '2px', borderRadius: '4px', zIndex: 2 },
    // Center dots within the wrapper
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
  },
  dot: {
    borderRadius: '50%',
    flexShrink: 0,
    pointerEvents: 'none',
    transition: 'all 0.2s cubic-bezier(0.4, 0, 0.2, 1)',
  },
  fullKeyFrameDot: {
    height: '10px',
    width: '10px',
  },
  fullDot: {
    height: '7px',
    width: '7px',
  },
  emptyDot: {
    height: '5px',
    width: '5px',
    backgroundColor: '#fff',
    border: '2px solid',
  },
  emptyKeyFrameDot: {
    height: '8px',
    width: '8px',
    backgroundColor: '#fff',
    border: '2px solid',
  },
});

// Use forwardRef to allow for Material UI Tooltip to use this as a child.
const ImageFrameDot = React.forwardRef(
  ({ isKeyframe = false, isEmpty = false, onMouseOver = () => {}, onMouseLeave = () => {}, color, position, targetSpacing = 100, onClick = () => {}, ...tooltipProps }, ref) => {
    const { classes } = useStyles();
    let className = classes.fullDot;
    if (isEmpty) {
      className = isKeyframe ? classes.emptyKeyFrameDot : classes.emptyDot;
    } else if (isKeyframe) {
      className = classes.fullKeyFrameDot;
    }
    const getBackgroundColor = () => (isEmpty ? '#fff' : color);
    const getBorderColor = () => (!isEmpty ? '#fff' : color);

    return (
      <button
        type="button"
        {...tooltipProps}
        ref={ref}
        style={{
          left: `calc(${position} - min(12px, ${targetSpacing / 2}%))`,
          width: `min(24px, ${targetSpacing}%)`,
        }}
        className={classes.wrapper}
        onClick={onClick}
        // These two functions allow the hover event to bubble to the tooltip parent
        onMouseOver={onMouseOver}
        onMouseLeave={onMouseLeave}
      >
        <span
          className={`${classes.dot} ${className}`}
          style={{
            backgroundColor: getBackgroundColor(),
            borderColor: getBorderColor(),
          }}
        />
      </button>
    );
  }
);

ImageFrameDot.propTypes = {
  isKeyframe: PropTypes.bool,
  isEmpty: PropTypes.bool,
  onMouseOver: PropTypes.func,
  onMouseLeave: PropTypes.func,
  onClick: PropTypes.func,
  color: PropTypes.string.isRequired,
  position: PropTypes.string.isRequired,
  targetSpacing: PropTypes.number,
};



export default ImageFrameDot;
